import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CheckboxFilterField } from './filter-field-checkbox';
import { FilterFieldComponent } from '../filter-field.component';

@Component({
  selector: 'va-filter-checkbox',
  styleUrls: ['./filter-field-checkbox.scss'],
  template: `
    <mat-checkbox
      class="checkbox"
      color="primary"
      [checked]="filterField.value"
      (change)="applyFilter(!filterField.value)"
      />
    <span class="filter-name" (click)="applyFilter(!filterField.value)">
      @if (filterField.icon) {
        <img
          class="filter-name-icon"
          [src]="$safeNavigationMigration(filterField.icon?.url)"
          [width]="$safeNavigationMigration(filterField.icon?.width)"
          [height]="$safeNavigationMigration(filterField.icon?.height)"
          />
      }
      {{ '' + (filterField.disableTranslation ? filterField.name : (filterField.name | translate)) }}
    </span>
    @if (filterField.suffix) {
      <span class="filter-suffix" (click)="applyFilter(!filterField.value)">{{ filterField.suffix }}</span>
    }
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CheckboxFilterFieldComponent extends FilterFieldComponent<CheckboxFilterField> {}
